import React, {Component} from 'react';
import {Switch, withRouter} from "react-router";
import {Route} from "react-router-dom";
import {connect} from "react-redux";

import CssBaseline from '@material-ui/core/CssBaseline';
import {withStyles} from '@material-ui/core/styles';

import {AppBar, Snackbar, Toolbar, Typography} from "@material-ui/core";
import {Alert} from '@material-ui/lab';
import InfoPanel from "../InfoPanel/InfoPanel";
import LanguageSelect from "../LanguageSelect/LanguageSelect";
import AdminPage from "../Admin/AdminPage/AdminPage";
import LandingPage from "../../components/LandingPage/LandingPage";
import PlayersList from "../PlayersList/PlayersList";
import RegistrationForm from "../RegistrationForm/RegistrationForm";
import actions from "../../actions";

import {withTranslation} from "react-i18next";

const styles = (theme) => ({
    root: {
        display: 'flex'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    contentContainer: {
        paddingTop: '64px',
        width: '100%'
    },
    infoPanelDiv: {
        paddingTop: '72px',
        margin: theme.spacing(2)
    },
    infoPanel: {
        padding: theme.spacing(3)
    },
    appBar: {
    },
    languageButton: {
    },
    errorBar: {
        backgroundColor: theme.palette.error.dark
    }
});

const MyAlert = (props) => {
    return <Alert elevation={6} variant="filled" {...props} />;
};

const isoCodeToI18n = (language) => {
    if (!language || language.startsWith('en')) {
        return "en";
    } else if (language.startsWith('cs')) {
        return "cs";
    } else if (language.startsWith('de')) {
        return "de";
    }
    return "en";
};

class CzechOpenApp extends Component {
    languageSelectedHandler = (language) => {
        const {i18n} = this.props;
        i18n.changeLanguage(language);
    };

    componentDidMount() {
        this.props.loadInstance();
    }

    render() {
        const {classes, i18n} = this.props;

        let selectedLanguage = i18n.language;
        if (!selectedLanguage) {
            selectedLanguage = 'en';
        } else {
            selectedLanguage = isoCodeToI18n(selectedLanguage);
        }

        const errorSnackbarOpen = this.props.loadInstanceRetrySec;
        const errorSnackbarMsg = "Error loading tournament data - retry in " + this.props.loadInstanceRetrySec + " sec";

        return (
            <div className={classes.root}>
                <CssBaseline/>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" color="inherit" noWrap>Czech Open Darts Tournament</Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.contentContainer}>
                    <main className={classes.content}>
                        <Switch>
                            <Route exact path={process.env.REACT_APP_PREFIX + "/"}>
                                <LandingPage />
                            </Route>
                            <Route path={process.env.REACT_APP_PREFIX + "/players-list"}>
                                <PlayersList />
                            </Route>
                            <Route path={process.env.REACT_APP_PREFIX + "/registration"}>
                                <RegistrationForm />
                            </Route>
                            <Route path={process.env.REACT_APP_PREFIX + "/admin"}>
                                <AdminPage />
                            </Route>
                        </Switch>
                    </main>
                </div>
                <div className={classes.infoPanelDiv}>
                    <InfoPanel className={classes.infoPanel} language={selectedLanguage}/>
                    <LanguageSelect language={selectedLanguage} onLanguageSelected={this.languageSelectedHandler} />
                </div>
                <Snackbar open={errorSnackbarOpen} icon={false}>
                    <MyAlert severity="error">{errorSnackbarMsg}</MyAlert>
                </Snackbar>
            </div>
        );
    };
}

const mapStateToProps = (state) => {
    const loadInstanceRetrySeconds = typeof state.root.loadInstanceRetrySec !== 'undefined' ? state.root.loadInstanceRetrySec : 0;
    return {
        loadInstanceStarted: state.root.loadInstanceStarted,
        loadInstanceRetrySec: loadInstanceRetrySeconds,
        loadInstanceErrorCount: state.root.loadInstanceErrorCount
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadInstance: () => dispatch({type: actions.LOAD_LATEST_INSTANCE})
    };
};

export default withTranslation('messages')(withRouter(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(CzechOpenApp))));
